// extracted by mini-css-extract-plugin
export default {"daoContainer":"dao_daoContainer__zgJyf","proposalCard":"dao_proposalCard__Bgf-g","voteButton":"dao_voteButton__i2nPT","error":"dao_error__SRnMt","success":"dao_success__w2mbh"};